import {
  CHARIOT_AJOUT_ARTICLE,
  CHARIOT_SUPP_ARTICLE,
  CHARIOT_LIVRAISON_ADRESSE,
  CHARIOT_SAVE_METHODE_PAIEMENT,
  CHARIOT_SAVE_DATE_LIVRAISON,
  CHARIOT_RESET,
  CHARIOT_AJOUT_REQUETTE,
  CHARIOT_SAVE_VARIABLE_GLOB,
} from "../constantes/chariotConstantes";
export const chariotAjoutReducer = (
  state = {
    chariotListe: [],
    total: 0,
    livraisonAdresse: {},
    date_livraison: new Date(),
    varGlo: {},
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case CHARIOT_AJOUT_REQUETTE:
      return {
        ...state,
        loading: true,
      };
    case CHARIOT_AJOUT_ARTICLE:
      const item = action.payload;
      const itemExist = state.chariotListe.find(
        (x) => x.article === item.article
      );

      if (itemExist) {
        //...state c.a.d laisse les autres info sans changement
        return {
          ...state,
          loading: false,

          chariotListe: state.chariotListe.map((x) =>
            x.article === itemExist.article ? item : x
          ),
          total: state.chariotListe
            .reduce((acc, i) => acc + i.prix_total, 0)
            .toFixed(3),
        };
      } else {
        return {
          ...state,
          loading: false,
          total: state.chariotListe
            .reduce((acc, i) => acc + i.prix_total, 0)
            .toFixed(3),

          chariotListe: [...state.chariotListe, item],
        };
      }

    case CHARIOT_SUPP_ARTICLE:
      return {
        ...state,
        chariotListe: state.chariotListe.filter(
          (x) => x.article !== action.payload
        ),
      };
    case CHARIOT_LIVRAISON_ADRESSE:
      return {
        ...state,
        livraisonAdresse: action.payload,
      };
    case CHARIOT_SAVE_METHODE_PAIEMENT:
      return {
        ...state,
        methodePaie: action.payload,
      };
    case CHARIOT_SAVE_DATE_LIVRAISON:
      return {
        ...state,
        date_livraison: action.payload,
      };
    case CHARIOT_RESET:
      return { ...state, chariotListe: [] };
    case CHARIOT_SAVE_VARIABLE_GLOB:
      //pour garder le contenue de state actuel il faut mettre ...state ,l'element a changer comme notre cas return { ...state, varGlo: action.payload }
      return { ...state, varGlo: action.payload };
    default:
      return state;
  }
};
